



export class GxCardSubtle extends HTMLElement {

  constructor() {
    super()
    this.attachShadow({ mode: "open" })
    const temmplate = document.createElement("template")
    temmplate.innerHTML = `
<style>
  :host {
    display: block;
    border-radius: 10px;
    background-color: hsl(var(--mc-muted)/.1);
    padding: .5rem;
  }
</style>
<slot></slot>
`
    this.shadowRoot.append(temmplate.content.cloneNode(true))
  }
}


if (!window.customElements.get("gx-card-subtle")) {
  window.customElements.define("gx-card-subtle", GxCardSubtle)
}
